module.exports = {
    felton_quantitative_title: 'UPlus量化交易機器人',
    felton_quantitative_content1: '基於大數據和人工智慧的虛擬貨幣交易機器人',
    felton_quantitative_content2: '智慧構建讓您躺著賺錢',
    start_robot: '啟動機器人',
    product_description: '產品介紹',
    smart_contract_transactions: '智能合約交易',
    smart_contract_transactions_tip: '多空對沖震盪套利，風險可控',
    per_year: '年',
    fully_automated_spot_trading: '現貨全自動交易',
    fully_automated_spot_trading_tip: '雙幣種交易套利，適合橫盤屯幣',
    spot_grid_trading: '現貨網格交易',
    spot_martin_trading: '現貨馬丁交易',
    spot_martin_trading_tip: '單邊加倍押注降低成本，回調止盈',
    golden_triangle: '黃金三角交易',
    stable_income: '收益穩定',
    introduce: '介紹',
    golden_triangle_tip: '三個幣種迴圈交易,活躍度高',
    stability: '穩定性',
    rate_return: '收益率',
    capture_big_market: '捕捉大行情的能力',

    bb_transaction: 'BB交易',
    long_term_profit: '長期收益',
    bb_transaction_tip: '任意兩個幣種交易,適合橫盤屯幣',

    ub_transaction: 'UB交易',
    high_return: '高回報',
    ub_transaction_tip: '用USDT交易貨幣,獲得長期理財收益',

    grid_strategy: '網格策略',
    volatility_arbitrage: '震盪套利',
    grid_strategy_tip: '震盪行情自動低買高賣,穩定套利',

    martin_strategy: '馬丁策略',
    money_management: '倉位管理',
    martin_strategy_tip: '單邊加倍押注拉低成本,止盈回檔',

    contract_strategy: '對沖合約交易',
    stay_tuned_for: '收益率高',
    coming_soon: '合約多空對衝虧損，震蕩套利，超高收益',

    investment_advice: '產品優勢',
    reference_plan: '參攷建議',
    product_portfolio: '產品介紹',
    membership_level: '會員等級',
    for_people: '適合人群',
    features: '特點',
    monthly_return: '月收益率',
    turn_on: '創建',
    option_one: '選項一',
    option_one_introduce: '2個“黃金三角交易”\n+\n2個“BB”交易',
    option_one_for_people: '囤幣的比特幣信仰者',
    option_one_features: '多幣種交易,開單量大,收益長期穩定',
    option_two: '選項二',
    option_two_introduce: '1個“黃金三角交易”\n+\n5個“BB”交易',
    option_two_for_people: '囤幣的比特幣信仰者',
    option_two_features: '適合在平盤交易中獲利,不適合劇烈的市場波動',
    option_three: '選項三',
    option_three_introduce: '2個“UB交易”\n+\n1個“BB交易”',
    option_three_for_people: '獲得長期理財收益',
    option_three_features: '適合在市場劇烈波動時賺取收益,短期內可能有30%-50%的浮虧',
    no_suitable_solution: '沒有合適的解決方案,試試自定義',
    custom_solution: '解決方案？',

    product_advantages: '產品優勢',
    exclusive_strategy_model: '獨家策略模型',
    exclusive_strategy_model_tip: '智慧交易算灋和精細化倉位管理,强大的風控系統和靈活的點比特捕捉',
    fully_automatic_unattended: '全自動無人值守',
    fully_automatic_unattended_tip: '傻瓜式代理投資,降低時間成本,彌補信息不對稱,輕鬆享受睡後收益',
    financial_security: '資金安全保障',
    financial_security_tip: '支持API接入Binance、Okx等各大交易所,僅調用交易許可權,數位資產始終在自己的交易所帳戶中',
    regularly_update_policy: '定期更新策略',
    regularly_update_policy_tip: '强大的科技策略團隊,根據市場變化,定期調整參數、更新策略',

    opening_process: '開通流程',
    choose_exchange_connect: '選擇一個交易所並連接',
    recharge_fuel: '充值燃料費',
    quantification_robot: '全自動量化機器人',
    download_now: '立即下載',
    trading_robot: '智能合約交易 | 全自動量化機器人',
    quantitative_robot: '量化交易機器人',
    monthly_income: '月化收益高達',
    cryptocurrency: '百萬加密貨幣投資者信賴',
    add_official: '添加官方電報',
    subscribe: '訂閱官方頻道',
    download_app: '立即下載App',
    ios_download: 'iOS 下載',
    android_download: 'Android 下載',
    more_download: '更多下載方式',
    view_more: '查看更多',
    start_robot: '開啟機器人',
    view_network_revenue: '查看全網收益',
    register_now: '註冊立享永久免费量化工具',
    registernow: '立即註冊',
    incognito_browsing: '您開啟了“無痕瀏覽”模式，這將影響您的正常使用，請先切換為普通瀏覽模式！',
    warn: '警告',
    sure: '確定',
    free_trading_bots: '4款免費交易機器人',
    cryptocurrency_is: '加密貨幣開創全新時代',
    u_plus_helps: 'U Plus 助您創造、增值及保管財富',
    top_performance: '頂級性能，极速交易',
    exchange_technology_driven: '交易所技術驅動，超低延遲，极速撮合',
    asset_protection: '資產保障，極致安全',
    asset_protection_tip: 'U Plus 符合 CCSS 標準，保障資產及數據安全',
    high_liquidity: '高流動，低點差',
    high_liquidity_tip: 'U Plus 合約槓桿交易，超高效率，最小滑點',
    service_24_7: '全天候服務',
    service_24_7_tip: '保證系統正常運行，提供全天候客戶服務',
    convenient_and_ease: '便捷易用',
    convenient_and_ease_tip: '提供多種訂單系統及交易工具，風險可控',
    trade_with_peace_of_mind: '隨時隨地，安心交易',
    platform_offers: 'U Plus 平台提供PC网页版、手機 Android、iOS App應用程序',
    cryptocurrency_is_era: '加密貨幣開創全新時代',
    start_your: '60秒開啟您的數字貨幣之旅',
    select_exchange_connect: '選擇一個交易所並連接',
    top_up_fuel: '充值燃料',
    users_all_over_the_world: '用戶遍佈全球',
    more_than_100_countries: '100多個國家和地區',
    total_earnings_network: '全網累計收益',
    total_return_entire_network: '全網累計收益率',
    has_been_operating_stably: '已穩定運營',
    day: '天',
    hours: '小時',
    robot_stability: '機器人穩定性',
    make_wealth_within_reach: '讓財富近在咫尺',
    everything_you_need: '您現在需要的一切都在 UPlus 應用程序中',
    ios_profile_download: 'iOS 描述文件下載',
    android_download: 'Android 下載',
    more_download: '更多下載方式',
    our_partners: '我們的合作夥伴',
    sure: '確 定',
    app_name: 'UPLUS智能交易APP',
    app_description: '全新期現策略日進斗金',
    app_description_tip: '速來體驗！',
    app_description_tip_note: '注：蘋果手機用戶需要翻牆使用！',
    purchase_successful: '購買成功，您已升級為',
    go_set_up_the_robot: '去設置機器人',
    your: '您的',
    order_has_not_yet_been_paid: '訂單尚未支付',
    to_complete: '去完成',
    see_you_next_time: '下次再說',
    major_upgrade: '重磅升級！',
    all_contract_users: '所有合約用戶燃料費/點卡',
    discount: '7折',
    exemptions_are_being_offered: '減免中...',
    live_broadcast: 'UPLUS 直播',
    closed: '已關閉',
    incentive_program: '獎勳方案',
    level: '級別',
    upgrade_conditions: '升級條件',
    award: '獎勳',
    things_to_note: '注意事項：',
    regular_users_enter: '普通用戶升級到Lv0後進入獎勳系統，規則裡的直推用戶指Lv0以上用戶',
    protection_period: 'Lv2、Lv3、Lv4分別有1個月的級別保護期，Lv5、Lv6分別有3個月的級別保護期',
    brokerage_incentive_program: '經紀商獎勳方案',
    omni_channel_rewards: '全渠道獎勳',
    level_4_and_above: 'Lv4以上可以申請成為經紀商，詳情請諮詢客服。',
    fuel_consumption_30_day: '30天燃料消耗≥30usdt',
    direct_pushes: '個直推',
    deduction_501_2000U: '30天扣費501-2000U',
    deduction_2001_10000U: '30天扣費2001-10000U',
    off_chain_201_500_people: '鏈下201-500人，30天扣費10001-30000U',
    blockchain_501_1000_people: '鏈下501-1000人，30天扣費30001-100000U',
    more_than_1001_people: '鏈下1001人以上，30天扣費大於100000U',
    home: '首頁',
    user: '用戶中心',
    robotics: '機器人中心',
    return_home: '返佣中心',
    security_center: '安全中心',
    browser_not: '您的瀏覽器不支持本地存儲',
    enter_maximum: '最多只能輸入500個字符',
    question_type: '請選擇問題類型',
    enter_description: '請輸入問題描述',
    sensitive_words: '包含敏感詞匯，請重新編輯！',
    images_must: '圖片只能是 JPG或者PNG 格式!',
    image_size: '圖片大小不能超過 12MB!',
    received_thank: '收到，非常感謝您提的寶貴意見',
    view_tutorial: '查看教程'
}
